import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import CatalogPage from './CatalogPage';

class ProductsPage extends React.Component {

    state = {
        catalogPages: null
    }

    componentDidMount() {
        this.setState({
            catalogPages: appSettingsProducts.catalogPages
        });
    }

    render() {
        const {props: {basket: {items, totalPrice}}, state: {catalogPages}} = this;

        if (catalogPages === null) {
            return null;
        }

        return (
                <React.Fragment>
                    {catalogPages && catalogPages.map(page => {
                        return <CatalogPage key={page.imgId} page={page} />;
                    })}
                    
                </React.Fragment>    
                );
    }
}

const mapStateToProps = (state) => ({
    basket: state.basket
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);